module.exports = __webpack_public_path__ + "img/job-pic.a0877dc3.jpeg";